






























































































import { getAutomations, deleteAutomation, patchArticle, deleteAutomationArticle } from '@/api/api';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import MetaDatatable from '@/models/MetaDatatable';
import Datatable from '@/components/Datatable.vue';
import { cloneDeep, get } from 'lodash';
import HeaderDatatable from '@/models/HeaderDatatable';

@Component({
    components: {
        Datatable
    },
    filters: {
        calculateTotalPrice(articles: any) {
            console.log(articles)
            let totalPrice = 0;
            for (const article in articles) {
                console.log(article)
                //@ts-ignore
                totalPrice += articles[article].price_ht
            }
            return totalPrice * 1.2;
        },
        formatDate(date: string) {
            return moment(date).format('L');
        },
    }
})
export default class AutomationDatatable extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 100,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            prescriber: undefined,
            program: undefined,
            status: undefined,
            customer: undefined,
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);

    @Prop() reload!: boolean;

    showEditAutomation = false;
    automation: any = {};

    @Watch('reload')
    async onReloadChange(value: boolean, oldValue: boolean) {
        console.log(value)
        if (value == true) {
            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
            this.$emit('reloadSuccessfull');
        }
    }

    editAutomation(automation: any) {
        this.automation = automation;
        this.showEditAutomation = true;
    }

    async patch() {
        this.actionDatatable({
            action: "edit",
            item: this.automation
        })
    }

    deleteDialog(automation: any) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: "Supprimer Automatisation",
            text: "Souhaitez vous vraiment supprimer cette automatisation",
            accept: () => this.acceptDeleteAlert(automation),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async deleteArticleFromAutomation(article: any) {
        const $vs = (this as any).$vs;
        //@ts-ignore
        this.$vs.loading({
            //@ts-ignore
            container: this.$refs.loadingContracts,
        });

        try {
            const { data } = await deleteAutomationArticle(this.automation.id, article.id);
            console.log(data)
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Création',
                text: `Création de l'automatisation réussie`,
            });
            const index = this.automation.articles.indexOf(article);
            if (index > -1) { // only splice array when item is found
                this.automation.articles.splice(index, 1); // 2nd parameter means remove one item only
            }

            //this.automation = automationReset;
            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                //@ts-ignore
                text: error.response.data.message,
            });
            //@ts-ignore
            this.$vs.loading.close(this.$refs.loadingContracts.$el);
            return;
        }
        //@ts-ignore
        this.$vs.loading.close(this.$refs.loadingContracts);

    }

    async acceptDeleteAlert(automation: any) {
        await this.actionDatatable({ action: 'delete', item: automation });
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: any | null;
    }) {
        const $vs = (this as any).$vs;
        const action = ev.action;
        const automation: any | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (automation && automation.id) {

                    try {
                        const articleId = automation.id
                        delete automation.id
                        await patchArticle(automation, articleId);

                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: "Article modifié"
                        });

                        const $datatable = this.$refs.datatable as Datatable;
                        $datatable.refresh();

                    } catch (error) {
                        const message = get(
                            error,
                            'response.data.message',
                            `Erreur lors de la modification de l'option`
                        );

                        $vs.notify({
                            color: 'danger',
                            position: 'top-right',
                            title: 'Erreur',
                            text: message,
                        });
                    }
                }

                break;
            case 'delete':
                if (automation && automation.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };

                    try {
                        await deleteAutomation(automation.id);

                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: "Automatisation supprimé",
                            text: "",
                        });

                        const $datatable = this.$refs.datatable as Datatable;
                        $datatable.refresh();
                    } catch (error) {
                        const message = get(
                            error,
                            'response.data.message',
                            `Erreur lors de la suppression de l'automatisation`
                        );

                        $vs.notify({
                            color: 'danger',
                            position: 'top-right',
                            title: 'Erreur',
                            text: message,
                        });
                    }
                }
                break;
        }
    }

    get columns(): HeaderDatatable[] {
        return [
            {
                title: 'Utilisateur relié',
                dataIndex: 'user',
                scopedSlots: {
                    customRender: 'user',
                },
            },
            {
                title: 'Prix TTC de la facture (Nombre d\'articles)',
                dataIndex: 'articles',
                scopedSlots: {
                    customRender: 'articles',
                },
            },
            {
                title: 'Date de début',
                dataIndex: 'start_at',
                scopedSlots: {
                    customRender: 'start_at',
                },
            },
            {
                title: 'Etat',
                dataIndex: 'paused',
                scopedSlots: {
                    customRender: 'paused',
                },
            },
            {
                title: 'Actions',
                dataIndex: 'action',
                scopedSlots: {
                    customRender: 'actions',
                },
                fixed: 'right',
            },
        ];
    }

    async fetch(meta: MetaDatatable) {
        const { data } = await getAutomations({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }

}
